import api from "./api";
import {
  BaseResponse,
  GroupResponse,
  ShipperResponse,
  UserResponse,
} from "../types/responses.type";
import { UserRequest } from "types/requestes.type";

class ShipperService {
  static async getShippers(): Promise<BaseResponse<ShipperResponse[]>> {
    try {
      const response = await api.get("/shipper/list");
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch shippers",
      };
    }
  }

  static async getShipper(
    shipperId: number
  ): Promise<BaseResponse<ShipperResponse>> {
    try {
      const response = await api.get(`/shipper/${shipperId}`);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch shipper",
      };
    }
  }

  static async getUsers(): Promise<BaseResponse<UserResponse[]>> {
    try {
      const response = await api.get(`/shipper/users`);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch shipper",
      };
    }
  }
  static async updateUser(editedUser: Partial<UserRequest>) {
    try {
      const response = await api.patch(`/shipper/user`, editedUser);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to update user",
      };
    }
  }
  static async createUser(editedUser: Partial<UserRequest>) {
    try {
      const response = await api.post(`/shipper/user`, editedUser);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to create user",
      };
    }
  }
}

export default ShipperService;
